"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Edit = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 32 32", "data-testID": "Edit" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.Path, { d: "M0 0h32v32H0z" }),
            react_1.default.createElement(react_native_svg_1.Path, { d: "M13.2 22.4 9 23l.6-4.2L20.4 8l3.6 3.6-10.8 10.8zm-3.6-3.6 3.6 3.6", stroke: color }))));
};
Edit.defaultProps = {
    color: '#0064CC',
    width: 32,
    height: 32,
};
exports.default = react_1.default.memo(Edit);
